import React, { useState } from "react";
import { toast } from "sonner";
import { apiError } from "@/lib/apiError";
import { Download, Loader2, Terminal } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { btnGhost } from "@/components/Brand";
import { SorterPreview } from "@/components/SorterPreview";

const saveBlob = (data, filename) => {
  const url = window.URL.createObjectURL(new Blob([data], { type: "text/plain" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

/** Download buttons for the two-stage sorter scripts (.bat / .sh). */
export const SorterDownloads = ({ path, filePrefix, titleKey, bodyKey, testIdPrefix, previewProjectId }) => {
  const { t } = useI18n();
  const [busy, setBusy] = useState("");

  const download = async (ext) => {
    setBusy(ext);
    try {
      const res = await api.get(`${path}.${ext}`, { responseType: "blob" });
      saveBlob(res.data, `${filePrefix}.${ext}`);
    } catch (err) {
      toast.error(apiError(err, t("sorter_failed")));
    } finally {
      setBusy("");
    }
  };

  return (
    <div className="border border-[#2A2A2A] bg-[#0F0F0F] p-7" data-testid={`${testIdPrefix}-panel`}>
      <p className="eyebrow flex items-center gap-2"><Terminal size={12} /> {t(titleKey)}</p>
      <p className="mt-3 text-sm text-[#A8A8A8] leading-relaxed max-w-xl">{t(bodyKey)}</p>
      <div className="mt-6 flex flex-wrap gap-3">
        <button data-testid={`${testIdPrefix}-bat-btn`} onClick={() => download("bat")} disabled={!!busy}
          className={btnGhost}>
          {busy === "bat" ? <Loader2 size={13} className="animate-spin" /> : <Download size={13} />}
          {t("download_windows")}
        </button>
        <button data-testid={`${testIdPrefix}-sh-btn`} onClick={() => download("sh")} disabled={!!busy}
          className={btnGhost}>
          {busy === "sh" ? <Loader2 size={13} className="animate-spin" /> : <Download size={13} />}
          {t("download_mac")}
        </button>
      </div>
      <p className="mt-4 text-[11px] text-[#707070] leading-relaxed max-w-xl" data-testid={`${testIdPrefix}-mac-hint`}>
        {t("mac_permission_hint")}
      </p>
      {previewProjectId && <div className="mt-6"><SorterPreview projectId={previewProjectId} /></div>}
    </div>
  );
};
